import { render, staticRenderFns } from "./VlAddActionModal.vue?vue&type=template&id=55907dc5&scoped=true&"
import script from "./VlAddActionModal.vue?vue&type=script&lang=js&"
export * from "./VlAddActionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55907dc5",
  null
  
)

export default component.exports